import loader from './pageLoader';
import loaderApp from './appLoader';
import App from '../containers/SearchApp';

loader(() => loaderApp(App, () => module.hot.accept()));
// loader(() => require('./../search'));
